import { createStore } from 'vuex'

export default createStore({
 state: {
   // sessionStorage를 먼저 확인, 없으면 localStorage 확인
   user: sessionStorage.getItem('user') 
     ? JSON.parse(sessionStorage.getItem('user'))
     : localStorage.getItem('user')
     ? JSON.parse(localStorage.getItem('user'))
     : null,
   token: sessionStorage.getItem('token') || localStorage.getItem('token') || null
 },
 mutations: {
   setUser(state, user) {
     state.user = user
   },
   setToken(state, token) {
     state.token = token
   },
   clearUserData(state) {
     state.user = null
     state.token = null
     localStorage.removeItem('user')
     localStorage.removeItem('token')
     sessionStorage.removeItem('user')
     sessionStorage.removeItem('token')
   },
   updateUser(state, user) {
     state.user = user
     if (localStorage.getItem('user')) {
       localStorage.setItem('user', JSON.stringify(user))
     }
     if (sessionStorage.getItem('user')) {
       sessionStorage.setItem('user', JSON.stringify(user))
     }
   }
 },
 actions: {
   login({ commit }, { user, token, rememberMe }) {
     commit('setUser', user)
     commit('setToken', token)
     
     if (rememberMe) {
       // 자동 로그인 선택 시 양쪽 다 저장
       localStorage.setItem('user', JSON.stringify(user))
       localStorage.setItem('token', token)
       sessionStorage.setItem('user', JSON.stringify(user))
       sessionStorage.setItem('token', token)
     } else {
       // 자동 로그인 미선택 시 sessionStorage에만 저장
       sessionStorage.setItem('user', JSON.stringify(user))
       sessionStorage.setItem('token', token)
       // localStorage는 클리어
       localStorage.removeItem('user')
       localStorage.removeItem('token')
     }
   },
   logout({ commit }) {
     commit('clearUserData')
   }
 },
 getters: {
   isLoggedIn: state => !!state.token,
   currentUser: state => state.user,
   getToken: state => state.token
 }
})